export default __webpack_public_path__ + "static/media/BrandAmbassador2.97628c02.jpg";